import { type FC, useCallback } from 'react';

import { Button } from '@vakantiesnl/components/src/atoms/Button';
import { useMicroCopyContext } from '@vakantiesnl/services/src/context/microCopyContext';

import { useCustomStyles } from './DepartureDateRangeSwitch.style';

export type Props = {
	/** The mode of the calendar, this way you can switch from single to range for example */
	calendarMode: 'single' | 'range';
	/** Function to call when clicking a button and change calendar mode */
	onToggleButtonSelect: (value: 'single' | 'range') => void;
};

export const DepartureDateRangeSwitch: FC<Props> = ({ calendarMode, onToggleButtonSelect }): JSX.Element => {
	const microCopies = useMicroCopyContext();
	const { classes } = useCustomStyles();

	const handleToggleButtonClick = useCallback(
		(flexibleDays: 'single' | 'range') => () => {
			onToggleButtonSelect(flexibleDays);
		},
		[onToggleButtonSelect],
	);

	return (
		<div className={classes.buttonWrapper}>
			<Button
				active={calendarMode === 'single'}
				onClick={handleToggleButtonClick('single')}
				size="small"
				variant="secondary"
			>
				{microCopies['departureDateRangeSwitch.calendar']}
			</Button>
			<Button
				active={calendarMode === 'range'}
				onClick={handleToggleButtonClick('range')}
				size="small"
				variant="secondary"
			>
				{microCopies['departureDateRangeSwitch.flexible']}
			</Button>
		</div>
	);
};
